import SearchCategories from "@/theme1/components/search/SearchCategories";
import RecentSearches from "@/theme1/components/search/RecentSearches";
import TrendingSearches from "@/theme1/components/search/TrendingSearches";

export default function SearchSuggestions({
  recentSearches,
  onSearch,
  onClearRecent,
  onSelect,
  trendingSearches,
  searchCategories,
}) {
  return (
    <div className="space-y-8">
      <RecentSearches
        searches={recentSearches}
        onSearch={onSearch}
        onClear={onClearRecent}
      />

      <TrendingSearches
        trendingSearches={trendingSearches}
        onSearch={onSearch}
      />

      <SearchCategories
        categories={searchCategories}
        onSelect={onSelect}
      />
    </div>
  );
}
